export const fixTeamNames = (matches) => {
  Object.keys(matches).forEach(mk => {
    const match = matches[mk]
    const { home, away } = match ?? {}
    match.home = ammendTeamName(home)
    match.away = ammendTeamName(away)
  })
}

export const ammendTeamName = (name) => {
  const _name = name ? name.trim() : name

  switch (_name) {

    case 'Apollo-Ridge':
      return 'Apollo Ridge'

    case 'Beaver Area':
      return 'Beaver'

    case 'Beaver C.C.':
      return 'Beaver County Christian'

    case 'Bethleham-Center':
    case 'Bethlehem-Center':
      return 'Beth Center'

    case 'Calvary Chapel':
      return 'Calvary Chapel'

    case 'Canon-McMillian':
    case 'Canon-McMillan':
    case 'Canon Mcmillian':
    case 'Canon Mac':
      return 'Canon McMillan'

    case 'Central Cath':
      return 'Central Catholic'

    case 'Char Houston':
      return 'Chartiers Houston'

    case 'Chartiers Vall':
      return 'Chartiers Valley'

    case 'Derry':
      return 'Derry Area'

    case 'Eden Christian Academy':
    case 'Eden Christian Acad.':
      return 'Eden Christian'

    case 'Elizabeth Fwd':
      return 'Elizabeth Forward'

    case 'Fort Cheery':
      return 'Fort Cherry'

    case 'Freedom Area':
      return 'Freedom'

    case 'Franklin Reg':
      return 'Franklin Regional'

    case 'Geibel Catholic':
      return 'Geibel'

    case 'Gbg Salem':
      return 'Greensburg Salem'

    case 'Greater Latrobe':
      return 'Latrobe'

    case 'Greensburg CC':
    case 'Greensburg C.C.':
    case 'Gbg Central Cth':
    case 'Greensburgh Central Cth':
      return 'Greensburg Central Catholic'

    case 'Hempfield Area':
      return 'Hempfield'

    case 'Hillcrest Academy':
      return 'Hillcrest Christian Academy'

    case 'Imani Christian Acad':
    case 'Imani Christian Acad.':
    case 'Imani Christian Academy':
      return 'Imani Christian'

    case 'Jefferson-Morgan':
    case 'Jeff Morgan':
      return 'Jefferson Morgan'

    case 'Keyston Oaks':
      return 'Keystone Oaks'

    case 'Kiski':
      return 'Kiski Area'

    case 'Laurel High':
      return 'Laurel Highlands'

    case 'Mcguffy':
      return 'McGuffey'

    case 'Mckeesport':
      return 'McKeesport'

    case 'Mount Pleasant':
      return 'Mt. Pleasant'

    case 'Neighborhood A.':
    case 'The Neighborhood Acad':
    case 'The Neighborhood Academy':
      return 'Neighborhood Academy'

    case 'North Allegh':
      return 'North Allegheny'

    case 'OLSH':
    case 'Olsh':
    case 'Our Lady of the Sacred Heart':
    case 'O.L. Sacred Heart':
    case 'Our Lady of Sacred Heart':
      return 'O.L.S.H.'

    case 'Penn-Trafford':
      return 'Penn Trafford'

    case 'Peters':
    case 'Peters Twp':
      return 'Peters Township'

    case 'Pine-Richland':
    case 'Pine-richland':
      return 'Pine Richland'

    case 'Propel':
      return 'Propel Braddock Hills'

    case 'Saint Joseph':
      return 'St. Joseph'

    case 'Seton La Salle':
    case 'Seton-la Salle':
      return 'Seton LaSalle'

    case 'Shady Side Aca':
      return 'Shady Side Academy'

    case 'Shaler':
      return 'Shaler Area'

    case 'South Alleghny':
      return 'South Allegheny'

    case 'South Side Beaver':
    case 'South Side':
      return 'South Side Area'

    case 'Sto Rox':
      return 'Sto-Rox'

    case 'Sto-Rox':
      return _name

    case 'Summit Acadmy':
    case 'The Summit Academy':
      return 'Summit Academy'

    case 'Thomas Jeff':
      return 'Thomas Jefferson'

    case 'Union':
      return 'Union Area'

    case 'Waynesburg Central':
      return 'Waynesburg'

    default:
      return _name ? _name.replace('-', ' ') : _name
  }
}